import React from "react";

// Returns a function that helps generate a unique incrementing number
const useIncrementalKey = (initialCount: number) => {
  const count = React.useRef<number>(initialCount);

  const getNext = React.useCallback(() => {
    const next = count.current + 1;
    count.current = next;
    return `${next}`;
  }, []);

  return {getNext};
};

export default useIncrementalKey;
